export default __webpack_public_path__ + "static/media/companyBg.71be6cfd.jpg";